export default __webpack_public_path__ + "static/media/support-experts-market.d33c6466.svg";